<div class="row">
    <div class="col-xs-12">
        <div class="card card-block card--box card--box--dashboard card--box--dashboard__item">
            <div class="mx-auto card--box--dashboard__item__header">
                <h2>
                    {{ 'Mental Health Checks & Appointments' | translate }}
                </h2>
            </div>
            <ng-container *ngIf="data">
                <div class="card card--box--dashboard__item__block mental-check">
                    <div class="row">
                        <div class="col-sm-4 col-xs-12 mental-check__col">
                            <div class="row mental-check__col__data">
                                <div class="col-md-12 col-xs-4 mental-check__col__header">
                                    <span class="header__h2">{{ data['registrations']}}</span>
                                </div>
                                <div class="col-md-12 col-xs-8 d-flex">
                                    <div class="col__left">
                                        <span class="mental-check__col__title">
                                            {{ 'Registrations' | translate}}
                                        </span>
                                        <span class="mental-check__col__content">
                                            {{ 'Patients who have completed the registration successfully' | translate}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-4 col-xs-12 mental-check__col">
                            <div class="row mental-check__col__data">
                                <div class="col-md-12 col-xs-4 mental-check__col__header">
                                    <span class="header__h2">{{ data['mental_health_checks']}}</span>
                                </div>
                                <div class="col-md-12 col-xs-8 d-flex">
                                    <div class="col__left">
                                        <span class="mental-check__col__title">
                                            {{ 'Mental Health Checks' | translate}}
                                        </span>
                                        <span class="mental-check__col__content">
                                            {{ 'Completed Mental Health Checks' | translate}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-4 col-xs-12 mental-check__col">
                            <div class="row mental-check__col__data">
                                <div class="col-md-12 col-xs-4 mental-check__col__header">
                                    <span class="header__h2">{{ data['completed_appointments']}}</span>
                                </div>
                                <div class="col-md-12 col-xs-8 d-flex">
                                    <div class="col__left">
                                        <span class="mental-check__col__title">
                                            {{ 'Completed appointments' | translate}}
                                        </span>
                                        <span class="mental-check__col__content">
                                            {{ 'Completed calls with patients' | translate}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr/>

                <div class="card card--box--dashboard__item__block mental-check">
                    <div class="row">
                        <div class="col-sm-4 col-xs-12 mental-check__col">
                            <div class="row mental-check__col__data">
                                <div class="col-md-12 col-xs-4 mental-check__col__header">
                                    <span class="header__h3 header__h3__bold">{{ data['minutes']}}</span>
                                </div>
                                <div class="col-md-12 col-xs-8 d-flex">
                                    <div class="col__left">
                                        <span class="mental-check__col__title">
                                            {{ 'Minutes' | translate}}
                                        </span>
                                        <span class="mental-check__col__content">
                                            {{ 'Average time a patient needs for the Mental Health Check' | translate}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-4 col-xs-12 mental-check__col">
                            <div class="row mental-check__col__data">
                                <div class="col-md-12 col-xs-4 mental-check__col__header">
                                    <span class="header__h3 header__h3__bold">{{ data['day_passed']}}</span>
                                </div>
                                <div class="col-md-12 col-xs-8 d-flex">
                                    <div class="col__left">
                                        <span class="mental-check__col__title">
                                            {{ 'Days passed' | translate}}
                                        </span>
                                        <span class="mental-check__col__content">
                                            {{ 'Average time in days which passed between completed Mental Health Check and appointment' | translate}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-4 col-xs-12 mental-check__col">
                            <div class="row mental-check__col__data">
                                <div class="col-md-12 col-xs-4 mental-check__col__header">
                                    <span class="header__h3 header__h3__bold">{{ data['unopen_sr']}}</span>
                                </div>
                                <div class="col-md-12 col-xs-8 d-flex">
                                    <div class="col__left">
                                        <span class="mental-check__col__title">
                                            {{ 'Unopened / cancelled Self-Reports' | translate}}
                                        </span>
                                        <span class="mental-check__col__content">
                                            {{ 'Self-Reports that have not been opened or that have been cancelled' | translate}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="line-button">
                    <span class="line-button__text" (click)="collapse = !collapse">
                        <ng-container *ngIf="collapse">
                            {{ 'Show more details' | translate}}
                        </ng-container>
                        <ng-container *ngIf="!collapse">
                            {{ 'Hide more details' | translate}}
                        </ng-container>
                    </span>
                </div>

                <ng-container *ngIf="!collapse">
                    <div class="card card--box--dashboard__item__block mental-check">
                        <div class="row">
                            <div class="col-sm-4 col-xs-12 mental-check__col">
                                <div class="row mental-check__col__data">
                                    <div class="col-md-12 col-xs-4 mental-check__col__header">
                                        <span class="header__h3">{{ data['completed_flows']}}</span>
                                    </div>
                                    <div class="col-md-12 col-xs-8">
                                        <div class="col__left">
                                            <span class="mental-check__col__title">
                                                {{ 'Completed processes this month' | translate}}
                                            </span>
                                            <span class="mental-check__col__content">
                                                {{ 'Total invoice' | translate}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-4 col-xs-12 mental-check__col">
                                <div class="row mental-check__col__data">
                                    <div class="col-md-12 col-xs-4 mental-check__col__header">
                                        <span class="header__h3">{{ data['no_shows']}}</span>
                                    </div>
                                    <div class="col-md-12 col-xs-8">
                                        <div class="col__left">
                                            <span class="mental-check__col__title">
                                                {{ 'No-shows' | translate}}
                                            </span>
                                            <span class="mental-check__col__content">
                                                {{ 'Partial invoice failure lump sum' | translate}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-4 col-xs-12 mental-check__col">
                                <div class="row mental-check__col__data">
                                    <div class="col-md-12 col-xs-4 mental-check__col__header">
                                        <span class="header__h3 header__h3__percent">{{ data['rate_sr_registration']}} %</span>
                                    </div>
                                    <div class="col-md-12 col-xs-8">
                                        <div class="col__left">
                                            <span class="mental-check__col__title">
                                                {{ 'Self-Reports / Registrations' | translate}}
                                            </span>
                                            <span class="mental-check__col__content">
                                                {{ 'Conversion Rate' | translate}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mental-check">
                            <div class="col-sm-4 col-xs-12 mental-check__col">
                                <div class="row mental-check__col__data">
                                    <div class="col-md-12 col-xs-4 mental-check__col__header">
                                        <span class="header__h3">{{ data['completed_calls']}}</span>
                                    </div>
                                    <div class="col-md-12 col-xs-8">
                                        <div class="col__left">
                                            <span class="mental-check__col__title">
                                                {{ 'Completed calls from previous month' | translate}}
                                            </span>
                                            <span class="mental-check__col__content">
                                                {{ 'Partial invoice call' | translate}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-4 col-xs-12 mental-check__col">
                                <div class="row mental-check__col__data">
                                    <div class="col-md-12 col-xs-4 mental-check__col__header">
                                        <span class="header__h3">{{ data['booked_called']}}</span>
                                    </div>
                                    <div class="col-md-12 col-xs-8">
                                        <div class="col__left">
                                            <span class="mental-check__col__title">
                                                {{ 'Call not booked / pending' | translate}}
                                            </span>
                                            <span class="mental-check__col__content">
                                                {{ 'Partial invoice without call' | translate}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-4 col-xs-12 mental-check__col">
                                <div class="row mental-check__col__data">
                                    <div class="col-md-12 col-xs-4 mental-check__col__header">
                                        <span class="header__h3 header__h3__percent">{{ data['rate_call_sr']}} %</span>
                                    </div>
                                    <div class="col-md-12 col-xs-8">
                                        <div class="col__left">
                                            <span class="mental-check__col__title">
                                                {{ 'Calls that took place / Self-Reports' | translate}}
                                            </span>
                                            <span class="mental-check__col__content">
                                                {{ 'Conversion Rate' | translate}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">

                            <div class="col-sm-4 col-xs-12 mental-check__col">
                                <div class="row mental-check__col__data">
                                    <div class="col-md-12 col-xs-4 mental-check__col__header">
                                        <span class="header__h3">{{ data['not_booked_called']}}</span>
                                    </div>
                                    <div class="col-md-12 col-xs-8">
                                        <div class="col__left">
                                            <span class="mental-check__col__title">
                                                {{ 'Amount of calls booked' | translate}}
                                            </span>
                                            <span class="mental-check__col__content">
                                                {{ 'Calls that have been booked but did not take place yet' | translate}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-4 offset-sm-4 col-xs-12 mental-check__col">
                                <div class="row mental-check__col__data">
                                    <div class="col-md-12 col-xs-4 mental-check__col__header">
                                        <span class="header__h3 header__h3__percent">{{ data['rate_call_registration']}} %</span>
                                    </div>
                                    <div class="col-md-12 col-xs-8">
                                        <div class="col__left">
                                            <span class="mental-check__col__title">
                                                {{ 'Calls that took place / Registrations' | translate}}
                                            </span>
                                            <span class="mental-check__col__content">
                                                {{ 'Conversion Rate' | translate}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>